/* eslint-disable react-hooks/exhaustive-deps */
import { Backdrop, Box, CircularProgress } from "@mui/material";
import i18next from "i18next";
import React, { useCallback, useEffect, useState } from "react";
import DrawerComponent from "../../components/drawerComponent/DrawerComponent";
import PageTitle from "../../components/pageTitle/PageTitle";
import AddDealerForm from "./components/addDealerForm/AddDealerForm";
import ButtonSection from "./components/buttonSection/ButtonSection";
import DealerDetails from "./components/dealerDetails/DealerDetails";
import DealerSearchSection from "./components/dealerSearchBoxSection/DealerSearchSection";
import DealerTableSection from "./components/dealerTableSection/DealerTableSection";
import DealerLogComponent from "./components/dealerLogComponent/DealerLogComponent";
import styles from "./dealer.module.scss";
import _ from "lodash";
import { getDealerList, getGroupPageListAPI } from "../../services/APIService";
import { useApiErrorModalContext } from "../../errorHandling/ApiErrorModalContext";
import { useLocation } from "react-router-dom";
import GroupTableComponent from "./components/groupTableComponent/GroupTableComponent";
import AddGroupComponent from "./components/addGroupComponent/AddGroupComponent";
import GroupDealerListComponent from "./components/groupDealerListComponent/GroupDealerListComponent";

export default function Dealers() {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(
    _.get(location, "state.currentTab", 0)
  );
  const [dealersList, setDealersList] = useState([]);
  const [dealersListResponse, setDealersListResponse] = useState({});
  const [groupsList, setGroupsList] = useState([]);
  const [groupListResponse, setGroupListResponse] = useState({});
  const [selectionModel, setSelectionModel] = useState([]);
  const [drawerState, setDrawerState] = useState(false);
  const [editDrawerState, setEditDrawerState] = useState(false);
  const [detailsDrawerState, setDetailsDrawerState] = useState(false);
  const [logDrawerState, setLogDrawerState] = useState(false);
  const [selectedDealerNo, setSelectedDealerNo] = useState(0);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [searchResultCount, setSearchResultCount] = useState(0);
  const [sortModel, setSortModel] = useState([]);
  const [bulkActionMenuFlag, setBulkActionMenuFlag] = useState(false);
  const [groupListTable, setGroupListTable] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  let isLoadingDealerList = false;
  let isLoadingGroupList = false;

  const [addGroupDrawerState, setAddGroupDrawerState] = useState(false);
  const [editGroupDrawerState, setEditGroupDrawerState] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedGroupId, setSelectedGroupId] = useState(0);
  const [inGroupTable, setInGroupTable] = useState(false);

  const [groupDetails, setGroupDetails] = useState({});
  const [exactSubcriptionList, setExactSubcriptionList] = useState([]);

  const [start, setStart] = useState(5);
  const { setApiErrorModalState } = useApiErrorModalContext();
  const defaultPageSize = 20;
  const defaultPageNumber = 1;
  let isLoadFirstTime = false;


  const defaultDealerApiParam = {
    IsDesc: false,
    Status: 3,
    PageNumber: defaultPageNumber,
    PageSize: defaultPageSize,
    ...(_.get(location, "state.currentTab", 0) === 1 && { Status: 3 }),
  };
  const defaultGroupListApiParam = {
    IsDesc: false,

    PageNumber: defaultPageNumber,
    PageSize: defaultPageSize,
    ...(_.get(location, "state.currentTab", 0) === 1 && { Status: 3 }),
  };
  const [dealerListApiParams, setDealerListApiParams] = useState(
    defaultDealerApiParam
  );
  const [groupListApiParams, setGroupListApiParams] = useState(
    defaultGroupListApiParam
  );

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const snackBarMessage = "A new dealer has been added successfully";
  const snackBarEditMessage = "Updated dealer successfully";
  const snackBarAddGroup = "A new group has been added successfully";
  const snackBarEditMessageGroup = "Updated Group successfully";
  const snackAssignGroup =
    "Group has beed updated for the dealers that you have selected";
  const [snackAssignGroupMessage, setSnackAssignGroupMessage] = useState(false);

  const fetchDealerList = useCallback(async () => {
    if (selectedTab === 0) {
      delete dealerListApiParams['Status'];
    }
    setSearchFlag(true);
    isLoadingDealerList = true;
    getDealerList(dealerListApiParams)
      ?.then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
          _.set(response, "status", 200);
          setSearchFlag(false);

          setApiErrorModalState({ error: response });
        } else if (_.get(response, "success", true) === false) {
          _.set(response, "status", 200);
          setApiErrorModalState({
            error: response,
          });
          setSearchFlag(false);
        } else {
          setDealersList(_.get(response, "dealerDtoList", []));
          setDealersListResponse(response);
          if (dealerListApiParams.hasOwnProperty("SearchTerm")) {
            setSearchResultCount(
              _.get(response, "paginationResult.totalCount", 0)
            );
          }
          isLoadingDealerList = false;
          isLoadingGroupList ? setSearchFlag(true) : setSearchFlag(false);

        }
      })
      .catch((err) => {
        setSearchFlag(false);

        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealerListApiParams, setApiErrorModalState]);

  const fetchGroupList = useCallback(async () => {
    setSearchFlag(true);
    isLoadingGroupList = true;
    const searchParams = localStorage.getItem('groupListSearchParams');
    const params = !_.isEmpty(searchParams) && isLoadFirstTime ? JSON.parse(searchParams) : groupListApiParams;

    getGroupPageListAPI(params)
      ?.then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
          _.set(response, "status", 200);
          setSearchFlag(false);
          setApiErrorModalState({ error: response });
        } else if (_.get(response, "success", true) === false) {
          _.set(response, "status", 200);
          setSearchFlag(false);
          setApiErrorModalState({
            error: response,
          });
        } else {
          setGroupsList(_.get(response, "dealerGroupDtoList", []));
          setGroupListResponse(response);
          if (groupListApiParams.hasOwnProperty("SearchTerm")) {
            setSearchResultCount(
              _.get(response, "paginationResult.totalCount", 0)
            );
          }
          isLoadingGroupList = false;
          isLoadingDealerList ? setSearchFlag(true) : setSearchFlag(false);
        }
      })
      .catch((err) => {
        setSearchFlag(false);
        setApiErrorModalState({ error: err });
      });
  }, [groupListApiParams, setApiErrorModalState]);

  useEffect(() => {
    const dealerListParams = localStorage.getItem('dealerListSearchParams');
    const groupListParams = localStorage.getItem('groupListSearchParams');
    
    isLoadFirstTime = true;
    if (!_.isEmpty(dealerListParams)) {
      const dealersearchParam = JSON.parse(dealerListParams);
      setDealerListApiParams(dealersearchParam);
    }
    if (!_.isEmpty(groupListParams)) {
      const groupSearchParam = JSON.parse(groupListParams);
      setGroupListApiParams(groupSearchParam);
    }
    if(!_.isEmpty(localStorage.getItem('dealerSearchSelectedTab'))){
      setSelectedTab(parseInt(localStorage.getItem('dealerSearchSelectedTab')));
    }else {
      setSelectedTab(0);
    }
  }, [])

  useEffect(() => {
    if (
      !_.isNull(window.sessionStorage.getItem("searchKeyWord")) &&
      !_.isEmpty(window.sessionStorage.getItem("searchKeyWord"))
    ) {
      handleSearch(window.sessionStorage.getItem("searchKeyWord"));
      window.sessionStorage.removeItem("searchKeyWord");
    } else {
      const searchParams = localStorage.getItem('dealerListSearchParams');
      if (isLoadFirstTime) {
        if (_.isEmpty(searchParams)) {
          fetchDealerList();
        }
      } else {
        fetchDealerList();
        localStorage.setItem('dealerListSearchParams', JSON.stringify(dealerListApiParams));
      }

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealerListApiParams]);

  useEffect(() => {    
    const searchParams = localStorage.getItem('groupListSearchParams');
      if (isLoadFirstTime) {
        if (_.isEmpty(searchParams)) {
          fetchGroupList();
        }
      } else {
        fetchGroupList();
        localStorage.setItem('groupListSearchParams', JSON.stringify(groupListApiParams));
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupListApiParams]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerState(!drawerState);
  };

  const toggleDetailsDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDetailsDrawerState(!detailsDrawerState);
  };

  const toggleEditDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setEditDrawerState(!editDrawerState);
  };

  const toggleLogDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setLogDrawerState(!logDrawerState);
  };

  const toggleAddGroupDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setAddGroupDrawerState(!addGroupDrawerState);
  };

  const toggleEditGroupDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setEditGroupDrawerState(!editGroupDrawerState);
  };

  const handleImportButtonClick = () => {
    alert("Import");
  };

  const handleAddDealerClick = () => {
    document.getElementById("contentWrapper").scrollIntoView = function () { };
    setSelectedDealerNo(0);
    setDrawerState(true);
    setBulkActionMenuFlag(false);
    setSelectionModel([]);
  };

  const handleAddGroupClick = () => {
    document.getElementById("contentWrapper").scrollIntoView = function () { };
    setAddGroupDrawerState(true);
    setGroupDetails({});
  };
  const handleTableSorting = useCallback(
    (sortingParam, type) => {
      if (!_.isEmpty(sortingParam)) {
        let query = sortingParam[0];
        if (type === "dealer") {
          setDealerListApiParams({
            ...dealerListApiParams,
            ...{
              IsDesc: query?.sort === "desc",
              OrderBy: query?.field,
            },
          });
        } else if (type === "group") {
          setGroupListApiParams({
            ...groupListApiParams,
            ...{
              IsDesc: query?.sort === "desc",
              OrderBy: query?.field,
            },
          });
        }

        setSortModel([
          {
            field: query?.field,
            sort: query?.sort,
          },
        ]);
      } else {
        if (type === "dealer") {
          delete dealerListApiParams["OrderBy"];
          setDealerListApiParams({
            ...dealerListApiParams,

            ...{
              IsDesc: false,
            },
          });
        } else if (type === "group") {
          delete groupListApiParams["OrderBy"];
          setGroupListApiParams({
            ...groupListApiParams,

            ...{
              IsDesc: false,
            },
          });
        }
        setSortModel([]);
      }
    },
    [dealerListApiParams, groupListApiParams]
  );
  const handleTabClick = (value) => {
    localStorage.setItem('dealerSearchSelectedTab', value);
    setSelectedTab(value);
    setSearchKeyWord("");
    setSearchResultCount(0);
    setSelectionModel([]);
    setSelectedGroup("");
    setSelectedGroupId(0);
    setInGroupTable(false);
    switch (value) {
      case 0: {
        delete defaultDealerApiParam["Status"];
        delete defaultDealerApiParam["DealerGrpId"];

        setDealerListApiParams(defaultDealerApiParam);
        break;
      }
      case 1: {
        delete defaultDealerApiParam["DealerGrpId"];
        setDealerListApiParams({ ...defaultDealerApiParam, ...{ Status: 3 } });
        break;
      }
      case 2: {
        delete defaultDealerApiParam["DealerGrpId"];
        setDealerListApiParams({ ...defaultDealerApiParam, ...{ Status: 1 } });
        break;
      }
      case 3: {
        delete defaultDealerApiParam["DealerGrpId"];
        setDealerListApiParams({ ...defaultDealerApiParam, ...{ Status: 2 } });
        break;
      }
      case 4: {
        delete defaultDealerApiParam["DealerGrpId"];
        setDealerListApiParams({ ...defaultDealerApiParam, ...{ Status: 0 } });
        break;
      }
      case 5: {
        setGroupListApiParams({ ...defaultGroupListApiParam });
        break;
      }
      default: {
        break;
      }
    }
  };
  const handleSearch = useCallback(
    (value) => {
      setSearchFlag(true);
      setSearchResultCount(null);

      if (selectedTab === 0) {
        delete defaultDealerApiParam["Status"];
      }
      else if (selectedTab === 2) {
        defaultDealerApiParam["Status"] = 1;
      }
      else if (selectedTab === 3) {
        defaultDealerApiParam["Status"] = 2;
      }
      else if (selectedTab === 4) {
        defaultDealerApiParam["Status"] = 0;
      }
      setSearchKeyWord(value);
      if (!_.isEmpty(value)) {
        setDealerListApiParams({
          ...defaultDealerApiParam,
          ...{ SearchTerm: value },
        });
      } else {
        delete defaultDealerApiParam["SearchTerm"];
        setDealerListApiParams(defaultDealerApiParam);
        setSearchResultCount(null);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedTab]
  );

  const handleGroupSearch = useCallback(
    (value) => {
      setSearchFlag(true);
      setSearchResultCount(null);
      setSearchKeyWord(value);
      if (!_.isEmpty(value)) {
        setGroupListApiParams({
          ...defaultGroupListApiParam,
          ...{ SearchTerm: value },
        });
      } else {
        delete defaultGroupListApiParam["SearchTerm"];
        setGroupListApiParams(defaultGroupListApiParam);
        setSearchResultCount(0);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const handleBack = () => {
    setStart(5);
    setDetailsDrawerState(true);
    handleCancel("Logs");
  };

  const handleCancel = (drawerType = "") => {
    switch (drawerType) {
      case "Edit": {
        setEditDrawerState(false);
        setSnackAssignGroupMessage(false);
        return;
      }
      case "Details": {
        setDetailsDrawerState(false);
        return;
      }
      case "Logs": {
        setLogDrawerState(false);
        return;
      }
      case "AddGroups": {
        setAddGroupDrawerState(false);
        return;
      }
      case "EditGroups": {
        setEditGroupDrawerState(false);
        return;
      }
      case "Add":
      default: {
        setDrawerState(false);
        return;
      }
    }
  };

  useEffect(() => {
    if (selectedGroupId !== 0) {
      delete defaultDealerApiParam["Status"];
      setDealersList([]);
      setDealerListApiParams({
        ...defaultDealerApiParam,
        ...{ DealerGrpId: selectedGroupId },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedGroupId]);

  const getSnackBarMessage = () => {
    if (snackAssignGroupMessage) {
      return snackAssignGroup;
    } else if (selectedDealerNo) {
      return snackBarEditMessage;
    } else {
      return snackBarMessage;
    }
  };

  const getTabContent = useCallback(() => {
    switch (selectedTab) {
      case 0:
      case 1: {
        return (
          <Box className="pageWrapper">
            <DealerSearchSection
              dealersList={dealersList}
              handleChange={handleSearch}
              searchKeyword={searchKeyWord}
              count={searchResultCount}
              placeholder="Search by Id, dealer, status, source"
              isBulkneeded={true}
              isBtnDisabled={searchFlag}
              selectedTab={selectedTab}
            />

            <DealerTableSection
              dealersList={dealersList}
              snackBarMessage={getSnackBarMessage()}
              isCheckboxSelection={true}
              bulkActionMenuFlag={bulkActionMenuFlag}
              setBulkActionMenuFlag={setBulkActionMenuFlag}
              setSnackAssignGroupMessage={setSnackAssignGroupMessage}
              selectionModel={selectionModel}
              setSelectionModal={setSelectionModel}
              openSnackbar={openSnackbar}
              setOpenSnackbar={setOpenSnackbar}
              setDetailsDrawerState={setDetailsDrawerState}
              setEditDrawerState={setEditDrawerState}
              setSelectedDealerNo={setSelectedDealerNo}
              searchKeyWord={searchKeyWord}
              selectedTab={selectedTab}
              pageSize={_.get(
                dealersListResponse,
                "paginationResult.pageSize",
                defaultPageSize
              )}
              pageNumber={_.get(
                dealersListResponse,
                "paginationResult.currentPage",
                defaultPageNumber
              )}
              handlePageChange={(pageNo) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageNumber: pageNo,
                })
              }
              handlePageSizeChange={(noOfRows) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageSize: noOfRows,
                })
              }
              totalRecords={_.get(
                dealersListResponse,
                "paginationResult.totalCount",
                0
              )}
              refreshTable={() => fetchDealerList()}
              onSortChange={(sortingParam) =>
                handleTableSorting(sortingParam, "dealer")
              }
              sortModel={sortModel}
              setSearchFlag={setSearchFlag}
            />
          </Box>
        );
      }
      case 2: {
        return (
          <Box className={`pageWrapper ${styles.ProspectWrapper}`}>
            <DealerSearchSection
              dealersList={dealersList}
              handleChange={handleSearch}
              searchKeyword={searchKeyWord}
              count={searchResultCount}
              placeholder="Search by Id, dealer, status, source"
              isBulkneeded={true}
              isBtnDisabled={searchFlag}
              selectedTab={selectedTab}
            />

            <DealerTableSection
              dealersList={dealersList}
              snackBarMessage={getSnackBarMessage()}
              isCheckboxSelection={true}
              bulkActionMenuFlag={bulkActionMenuFlag}
              setBulkActionMenuFlag={setBulkActionMenuFlag}
              setSnackAssignGroupMessage={setSnackAssignGroupMessage}
              selectionModel={selectionModel}
              setSelectionModal={setSelectionModel}
              openSnackbar={openSnackbar}
              setOpenSnackbar={setOpenSnackbar}
              setDetailsDrawerState={setDetailsDrawerState}
              setEditDrawerState={setEditDrawerState}
              setSelectedDealerNo={setSelectedDealerNo}
              searchKeyWord={searchKeyWord}
              selectedTab={selectedTab}
              pageSize={_.get(
                dealersListResponse,
                "paginationResult.pageSize",
                defaultPageSize
              )}
              pageNumber={_.get(
                dealersListResponse,
                "paginationResult.currentPage",
                defaultPageNumber
              )}
              handlePageChange={(pageNo) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageNumber: pageNo,
                })
              }
              handlePageSizeChange={(noOfRows) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageSize: noOfRows,
                })
              }
              totalRecords={_.get(
                dealersListResponse,
                "paginationResult.totalCount",
                0
              )}
              refreshTable={() => fetchDealerList()}
              onSortChange={(sortingParam) =>
                handleTableSorting(sortingParam, "dealer")
              }
              sortModel={sortModel}
              setSearchFlag={setSearchFlag}
            />
          </Box>
        );
      }

      case 3: {
        return (
          <Box className={`pageWrapper ${styles.JaWrapper}`}>
            <DealerSearchSection
              dealersList={dealersList}
              handleChange={handleSearch}
              searchKeyword={searchKeyWord}
              count={searchResultCount}
              placeholder="Search by Id, dealer, status, source"
              isBulkneeded={true}
              isBtnDisabled={searchFlag}
              selectedTab={selectedTab}
            />

            <DealerTableSection
              dealersList={dealersList}
              snackBarMessage={getSnackBarMessage()}
              isCheckboxSelection={true}
              bulkActionMenuFlag={bulkActionMenuFlag}
              setBulkActionMenuFlag={setBulkActionMenuFlag}
              setSnackAssignGroupMessage={setSnackAssignGroupMessage}
              selectionModel={selectionModel}
              setSelectionModal={setSelectionModel}
              openSnackbar={openSnackbar}
              setOpenSnackbar={setOpenSnackbar}
              setDetailsDrawerState={setDetailsDrawerState}
              setEditDrawerState={setEditDrawerState}
              setSelectedDealerNo={setSelectedDealerNo}
              searchKeyWord={searchKeyWord}
              selectedTab={selectedTab}
              pageSize={_.get(
                dealersListResponse,
                "paginationResult.pageSize",
                defaultPageSize
              )}
              pageNumber={_.get(
                dealersListResponse,
                "paginationResult.currentPage",
                defaultPageNumber
              )}
              handlePageChange={(pageNo) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageNumber: pageNo,
                })
              }
              handlePageSizeChange={(noOfRows) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageSize: noOfRows,
                })
              }
              totalRecords={_.get(
                dealersListResponse,
                "paginationResult.totalCount",
                0
              )}
              refreshTable={() => fetchDealerList()}
              onSortChange={(sortingParam) =>
                handleTableSorting(sortingParam, "dealer")
              }
              sortModel={sortModel}
              setSearchFlag={setSearchFlag}
            />
          </Box>
        );
      }
      case 4: {
        return (
          <Box className={`pageWrapper ${styles.NeeWrapper}`}>
            <DealerSearchSection
              dealersList={dealersList}
              handleChange={handleSearch}
              searchKeyword={searchKeyWord}
              count={searchResultCount}
              placeholder="Search by Id, dealer, status, source"
              isBulkneeded={true}
              isBtnDisabled={searchFlag}
              selectedTab={selectedTab}
            />

            <DealerTableSection
              dealersList={dealersList}
              snackBarMessage={getSnackBarMessage()}
              isCheckboxSelection={true}
              bulkActionMenuFlag={bulkActionMenuFlag}
              setBulkActionMenuFlag={setBulkActionMenuFlag}
              setSnackAssignGroupMessage={setSnackAssignGroupMessage}
              selectionModel={selectionModel}
              setSelectionModal={setSelectionModel}
              openSnackbar={openSnackbar}
              setOpenSnackbar={setOpenSnackbar}
              setDetailsDrawerState={setDetailsDrawerState}
              setEditDrawerState={setEditDrawerState}
              setSelectedDealerNo={setSelectedDealerNo}
              searchKeyWord={searchKeyWord}
              selectedTab={selectedTab}
              pageSize={_.get(
                dealersListResponse,
                "paginationResult.pageSize",
                defaultPageSize
              )}
              pageNumber={_.get(
                dealersListResponse,
                "paginationResult.currentPage",
                defaultPageNumber
              )}
              handlePageChange={(pageNo) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageNumber: pageNo,
                })
              }
              handlePageSizeChange={(noOfRows) =>
                setDealerListApiParams({
                  ...dealerListApiParams,
                  PageSize: noOfRows,
                })
              }
              totalRecords={_.get(
                dealersListResponse,
                "paginationResult.totalCount",
                0
              )}
              refreshTable={() => fetchDealerList()}
              onSortChange={(sortingParam) =>
                handleTableSorting(sortingParam, "dealer")
              }
              sortModel={sortModel}
              setSearchFlag={setSearchFlag}
            />
          </Box>
        );
      }
      case 5: {
        return (
          <Box className="pageWrapper">
            <DealerSearchSection
              dealersList={groupsList}
              handleChange={handleGroupSearch}
              searchKeyword={searchKeyWord}
              count={searchResultCount}
              placeholder="Search by group Id, name, city"
              isBulkneeded={false}
              isBtnDisabled={searchFlag}
              selectedTab={selectedTab}
            />
            <GroupTableComponent
              groupList={groupsList}
              snackBarMessage={
                _.isEmpty(groupDetails)
                  ? snackBarAddGroup
                  : snackBarEditMessageGroup
              }
              openSnackbar={openSnackbar}
              setOpenSnackbar={setOpenSnackbar}
              onSortChange={(sortingParam) =>
                handleTableSorting(sortingParam, "group")
              }
              sortModel={sortModel}
              setGroupDetails={setGroupDetails}
              setEditGroupDrawerState={setEditGroupDrawerState}
              setGroupListTable={setGroupListTable}
              setSelectedGroup={setSelectedGroup}
              setSelectedGroupId={setSelectedGroupId}
              setInGroupTable={setInGroupTable}
              pageSize={_.get(
                groupListResponse,
                "paginationResult.pageSize",
                defaultPageSize
              )}
              pageNumber={_.get(
                groupListResponse,
                "paginationResult.currentPage",
                defaultPageNumber
              )}
              handlePageChange={(pageNo) =>
                setGroupListApiParams({
                  ...groupListApiParams,
                  PageNumber: pageNo,
                })
              }
              handlePageSizeChange={(noOfRows) =>
                setGroupListApiParams({
                  ...groupListApiParams,
                  PageSize: noOfRows,
                })
              }
              totalRecords={_.get(
                groupListResponse,
                "paginationResult.totalCount",
                0
              )}
              refreshTable={() => fetchGroupList()}
            />
          </Box>
        );
      }
      default: {
        return null;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedTab,
    dealersList,
    handleSearch,
    searchKeyWord,
    searchResultCount,
    selectedDealerNo,
    bulkActionMenuFlag,
    selectionModel,
    openSnackbar,
    dealersListResponse,
    sortModel,
    dealerListApiParams,
    fetchDealerList,
    handleTableSorting,
    groupsList,
    handleGroupSearch,
    groupDetails,
    setGroupListTable,
    groupListResponse,
    groupListApiParams,
    fetchGroupList,
    setSnackAssignGroupMessage,
    snackAssignGroup,
    snackAssignGroupMessage,
  ]);

  const getGroupDealerPageUI = () => {
    return (
      <Box>
        {/* fix it make this as component and move to seprate page */}
        <GroupDealerListComponent
          setGroupListTable={setGroupListTable}
          setSelectedGroup={setSelectedGroup}
          selectedGroup={selectedGroup}
          setSelectedGroupId={setSelectedGroupId}
          setInGroupTable={setInGroupTable}
        />
        <Box className="pageWrapper">
          <Box className={styles.groupTextWrapper}>{`${i18next.t(
            "List of dealers linked"
          )}:`}</Box>
          <DealerTableSection
            dealersList={dealersList} //Once API Integration change name to GroupList
            snackBarMessage={
              selectedDealerNo ? snackBarEditMessage : snackBarMessage
            }
            isCheckboxSelection={false}
            selectionModel={selectionModel}
            setSelectionModal={setSelectionModel}
            openSnackbar={openSnackbar}
            setOpenSnackbar={setOpenSnackbar}
            setDetailsDrawerState={setDetailsDrawerState}
            setEditDrawerState={setEditDrawerState}
            setSelectedDealerNo={setSelectedDealerNo}
            selectedTab={selectedTab}
            inGroupTable={inGroupTable}
            pageSize={_.get(
              dealersListResponse,
              "paginationResult.pageSize",
              defaultPageSize
            )}
            pageNumber={_.get(
              dealersListResponse,
              "paginationResult.currentPage",
              defaultPageNumber
            )}
            handlePageChange={(pageNo) =>
              setDealerListApiParams({
                ...dealerListApiParams,
                PageNumber: pageNo,
              })
            }
            handlePageSizeChange={(noOfRows) =>
              setDealerListApiParams({
                ...dealerListApiParams,
                PageSize: noOfRows,
              })
            }
            totalRecords={_.get(
              dealersListResponse,
              "paginationResult.totalCount",
              0
            )}
            refreshTable={() => fetchDealerList()}
            onSortChange={(sortingParam) =>
              handleTableSorting(sortingParam, "dealer")
            }
            sortModel={sortModel}
          />
        </Box>
      </Box>
    );
  };
  const getDealerPageUI = () => {
    return (
      <Box>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={searchFlag}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <PageTitle title={i18next.t("Dealers")} data-testid="pagetitle" />
        <ButtonSection
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          handleImportButtonClick={handleImportButtonClick}
          handleAddDealerClick={handleAddDealerClick}
          handleTabClick={handleTabClick}
          handleAddGroupClick={handleAddGroupClick}
          buttonList={[
            {
              title: "All dealers",
              iconStyle: styles.listIcon,
              count: _.get(dealersListResponse, "totalDealers", 0),
              Styles: styles.listStyles,
            },
            {
              title: "Pending",
              iconStyle: styles.pendingIcon,
              count: _.get(dealersListResponse, "totalPendingDealer", 0),
              Styles: styles.pendingStyles,
            },
            {
              title: " Ja",
              iconStyle: styles.jaIcon,
              count: _.get(dealersListResponse, "totalJaDealer", 0),
              Styles: styles.jaStyles,
            },
            {
              title: "Prospect",
              iconStyle: styles.prospectIcon,
              count: _.get(dealersListResponse, "totalProspectDealer", 0),
              Styles: styles.prospectStyles,
            },
            {
              title: " Nee",
              iconStyle: styles.neeIcon,
              count: _.get(dealersListResponse, "totalNeeDealer", 0),
              Styles: styles.neeStyles,
            },
            {
              title: "Groups",
              iconStyle: styles.groupIcon,
              count: _.get(dealersListResponse, "totalDealerGroup", 0),
              Styles: styles.groupStyles,
            },

          ]}
        />
        {getTabContent()}
      </Box>
    );
  };
  return (
    <Box className={styles.dealerWrapper} data-testid="dealers">
      {groupListTable ? getGroupDealerPageUI() : getDealerPageUI()}
      {/* Add Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleDrawer}
        drawerState={drawerState}
        setDrawerState={setDrawerState}
        title={"Add new dealer"}
        contentSection={
          <Box className={styles.boxWrapper}>
            <AddDealerForm
              onCancel={() => handleCancel("Add")}
              setShowMessage={setOpenSnackbar}
              dealerNo={0}
              refreshTable={() => fetchDealerList()}
            />
          </Box>
        }
      />
      {/* Details Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleDetailsDrawer}
        drawerState={detailsDrawerState}
        setDrawerState={setDetailsDrawerState}
        title={`${i18next.t("Dealer details")} - #${selectedDealerNo}`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <DealerDetails
              onCancel={() => handleCancel("Details")}
              dealerNo={selectedDealerNo}
              setEditDrawerState={setEditDrawerState}
              setDetailsDrawerState={setDetailsDrawerState}
              setLogDrawerState={setLogDrawerState}
              setSnackAssignGroupMessage={setSnackAssignGroupMessage}
              setExactSubcriptionList={setExactSubcriptionList}
            />
          </Box>
        }
      />
      {/* Edit Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleEditDrawer}
        drawerState={editDrawerState}
        setDrawerState={setEditDrawerState}
        title={`Edit dealer`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <AddDealerForm
              onCancel={() => handleCancel("Edit")}
              setShowMessage={setOpenSnackbar}
              dealerNo={selectedDealerNo}
              refreshTable={() => fetchDealerList()}
              exactSubcriptionList={exactSubcriptionList}
            />
          </Box>
        }
      />

      {/* Log Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleLogDrawer}
        drawerState={logDrawerState}
        setDrawerState={setLogDrawerState}
        title={`${i18next.t("Dealer logs")} - #${selectedDealerNo}`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <DealerLogComponent
              onBack={() => handleBack()}
              start={start}
              setStart={setStart}
              id={selectedDealerNo}
            />
          </Box>
        }
      />

      {/* Add Group Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleAddGroupDrawer}
        drawerState={addGroupDrawerState}
        setDrawerState={setAddGroupDrawerState}
        title={i18next.t("Add a group")}
        contentSection={
          <Box className={styles.boxWrapper}>
            <AddGroupComponent
              handleCancel={() => handleCancel("AddGroups")}
              setAddGroupDrawerState={setAddGroupDrawerState}
              setOpenSnackbar={setOpenSnackbar}
              groupName={""}
              refreshTable={() => fetchGroupList()}
              id={0}
            />
          </Box>
        }
      />

      {/* Edit Group Drawer  */}
      <DrawerComponent
        position="right"
        toggleDrawer={toggleEditGroupDrawer}
        drawerState={editGroupDrawerState}
        setDrawerState={setEditGroupDrawerState}
        title={`${i18next.t("Edit group")} - #${_.get(groupDetails, "id", 0)}`}
        contentSection={
          <Box className={styles.boxWrapper}>
            <AddGroupComponent
              handleCancel={() => handleCancel("EditGroups")}
              setAddGroupDrawerState={setEditGroupDrawerState}
              setOpenSnackbar={setOpenSnackbar}
              refreshTable={() => fetchGroupList()}
              id={_.get(groupDetails, "id", 0)}
              groupDetails={groupDetails}
            />
          </Box>
        }
      />
    </Box>
  );
}
